export const DIOPTRA_REVIEW_ID = 'dioptra_review_id';
export const DIOPTRA_TEST_REVIEW_ID = 'dioptra_test_review_id';
export const DIOPTRA_DOCUMENT_REVIEWED = 'dioptra_document_reviewed';
export const DIOPTRA_CHAT_CONVERSATION_ID = 'dioptra_chat_conversation_id';
export const DIOPTRA_LOGIN_METHOD = 'dioptra_login_method';
export const DIOPTRA_WOPI_ENV_APPLIED = 'dioptra_wopi_env_applied';

